import SubtitleSoundLocalization from './SubtitleSoundLocalization.vue';

export default {
  SubtitleSoundLocalization,
};
